export enum JobStatus {
  QUEUED = 'QUEUED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED',
}

export interface PublicJobDto<Data = object, Result = object> {
  status: JobStatus;
  progress: number | object;
  finishedOn: string | null;
  processedOn: string | null;
  timestamp: string;
  failedReason: string;
  result: Result | null;
  data: Data | null;
}
